var exports = {
  "o": "StyledTableRow__iZeZYD",
};

module.exports = exports;
